export default __webpack_public_path__ + "static/media/contact1.f3f47f77.jpeg";